var React = require('react');

function ThickArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.58336 1.80526L7.16672 7.38867L1.58336 12.9721","stroke":"black","strokeWidth":"2","strokeLinecap":"round"}));
}

ThickArrowRight.defaultProps = {"width":"9","height":"14","viewBox":"0 0 9 14","fill":"none"};

module.exports = ThickArrowRight;

ThickArrowRight.default = ThickArrowRight;
